import { boolean, date, object, string, ref, } from 'yup';
import { mobilePhoneRegex } from '@enquiryForm/validation/testPhone';
import passwordValidation from '@widgets/shared/passwordValidation';
const formSpec = {
    firstName: string().required('This field is required'),
    surname: string().required('This field is required'),
    dateOfBirth: date()
        .required('This field is required'),
    mobile: string().required('This field is required').matches(mobilePhoneRegex, {
        message: 'Phone number is invalid',
    }),
    email: string()
        .required('This field is required')
        .email('Please enter a valid email address'),
    confirmEmail: string()
        .required('Please retype your email address')
        .email()
        .oneOf([ref('email')], 'Email addresses must match'),
    addressLine1: string().required('This field is required'),
    addressLine2: string(),
    // addressLine3: string(),
    addressTown: string().required('This field is required'),
    addressPostcode: string().required('This field is required'),
    addressCountry: string(),
    marketingPreferences: boolean(),
    password: string()
        .required('Password is required')
        .matches(passwordValidation, 'Your password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, and one number.'),
    confirmPassword: string()
        .required('Please retype your password')
        .oneOf([ref('password')], 'Passwords must match'),
};
export const registerFormSchema = object(formSpec);
